<template>
  <div v-if="isEnabled(blockName, field)">
    <b-form-group
      :label="makeLabel(blockName, field)"
      :label-for="makeId(field)"
      :state="state[field]"
      :invalid-feedback="invalid[field]"
      :description="makeDesc(blockName, field)"
    >
      <b-form-select
        :id="makeId(field)"
        v-model="data[field]"
        autocomplete="nope"
        :name="makeName(field)"
        :options="makeSelectOptions(blockName, field, [data[field]])"
        :state="state[field]"
      />
    </b-form-group>
    <b-form-group
      v-if="isEnabled(blockName, otherField) && isOther"
      :label="makeLabel(blockName, otherField)"
      :description="makeDesc(blockName, otherField)"
      :label-for="makeId(otherField)"
      :state="state[otherField]"
      :invalid-feedback="invalid[otherField]"
    >
      <b-form-input
        :id="makeId(otherField)"
        v-model="data[otherField]"
        autocomplete="nope"
        :name="makeName(otherField)"
        :state="state[otherField]"
        type="text"
      />
    </b-form-group>
  </div>
</template>

<script>
import FormFieldsMixin from "@/mixins/FormFieldsMixin";
import { isOther } from "@/form-utils";

/**
 * Component for composite fields which contains main field with single value from options and "_other" field.
 * For exmample: relgion/religion_other, industry/industry_other.
 */
export default {
  name: "OptionsFieldSelect",
  mixins: [FormFieldsMixin],
  props: {
    data: { required: true, type: Object },
    blockName: { required: true, type: String },
    field: { required: true, type: String },
    state: { required: true, type: Object },
    invalid: { required: true, type: Object },
    prefix: { required: true, type: String },
  },
  computed: {
    otherField() {
      return this.field + "_other";
    },
    isOther() {
      return isOther(this.data[this.field]);
    },
  },
};
</script>
